import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { getAppStatus } from 'single-spa';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { HelpersService } from 'src/app/shared/services/helpers/helpers-onboarding.service';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';

import { OpEnum } from '../../../shared/enums/op.enum';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';

import { ChannelCommunicatorService } from '../../../shared/services/communicator/channel-communicator/channel-communicator.service';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
@Component({
  selector: 'app-step-process',
  templateUrl: './process.component.html',
  styleUrls: ['./process.component.scss'],
})

export class ProcessComponent implements OnInit {

  @Output() continueClick = new EventEmitter();
  steps: any;
  postLogin: boolean;
  product_type: string;
  productSelected: any;
  back: any;
  continueEmit() {
    this.continueClick.emit();
  }

  constructor(
    private navigationService: NavigationService,
    private parametersService: ParametersService,
    public copyService: CopyService,
    private headerService: HeaderService,
    private abreCuentasService: AbreCuentasService,
    private helperService: HelpersService,
    private loaderService: LoaderService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private biocatchService: BioCatchService,
  ) {
    this.headerService.show(false, true, true);
  }

  ngOnInit() {
    const isEvidente = this.biocatchService.isEvidenteCase();
    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    this.biocatchService.changeContext(StepBiocatchEnum.solicitud, product, false, isEvidente);
    this.postLogin = this.abreCuentasService.getPostlogin();
    this.productSelected = this.abreCuentasService.getproductSelected();
    this.product_type = this.productSelected.product_type;
    if (this.abreCuentasService.getProductsSelects().length >= 2 && !this.postLogin) {
      this.steps = this.parametersService.getSetting(OpEnum.REVOLVING_STEPS_MULTI);
    } else if (this.postLogin && this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE
      || this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC
      || this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING
      || this.product_type === BUSINESS_CONST.MULTI) {
      this.steps = this.parametersService.getSetting(OpEnum.REVOLVING_STEPS_POST);
    } else {
      this.steps = this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING ? this.parametersService.getSetting(OpEnum.LIVING_STEPS)
        : this.parametersService.getSetting(OpEnum.REVOLVING_STEPS);
    }
    const status = getAppStatus('simulator');
    status === 'MOUNTED' ? this.helperService.unRegisterAplication('simulator') : console.log();
    this.loaderService.hide('null');
    this.previous();
  }

  next() {
    const codeChannel = this.channelCommunicatorService.getChannelId();
    let codeNextDefault = '200';
    if (this.abreCuentasService.viewOptionMultiProduct) {
      if (codeChannel === CHANNEL.SUPERAPP.CODE || codeChannel === CHANNEL.PORTALPN.CODE || codeChannel === CHANNEL.PORTALPN2.CODE) {
        codeNextDefault = '201';
      } else if (codeChannel === CHANNEL.PORTALO.CODE) {
        codeNextDefault = '200';
      }
    }
    this.navigationService.nextStep(codeNextDefault);
  }

  previous() {
    this.back = '';
    if (this.abreCuentasService.getProductsSelects().find(product => product.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN)) {
      if (this.abreCuentasService.getProductsSelects().length >= 2) {
        this.back = '200';
      } else {
        this.back = '205';
      }
    }
  }
}
